/*
  cfw-filter-bar.js  (COLLECTIONS agent, 2026-09-16)
  Collection page helpers, all delegated so they survive Horizon's
  section re-render after each filter change:
  - "Sort" button: opens the filter drawer at the sort control.
  - "Show N styles": after the drawer closes, scroll to the top of the grid.
  - Active-filter chips: update in place through the facets form.
  - "Show more (N more)": append the next page of cards below the grid.
*/

const qs = (sel, root = document) => root.querySelector(sel);

function openDrawer() {
  const drawer = document.getElementById('filters-drawer');
  if (drawer && typeof drawer.showDialog === 'function') {
    drawer.showDialog();
    return drawer;
  }
  return null;
}

function scrollToGrid() {
  const grid = document.getElementById('ResultsList');
  if (!grid) return;
  const header = document.querySelector('header-component');
  const offset = (header ? header.offsetHeight : 0) + 72;
  const top = grid.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(top, 0), behavior: 'auto' });
}

async function showMore(link) {
  const next = link.getAttribute('data-cfw-next') || link.getAttribute('href');
  const sectionId = link.getAttribute('data-cfw-section');
  if (!next || !sectionId) return;

  const wrapper = link.closest('[data-cfw-show-more]');
  const grid = document.querySelector(`#ResultsList .product-grid`);
  if (!grid) {
    window.location.href = next;
    return;
  }

  link.setAttribute('aria-busy', 'true');
  try {
    const url = new URL(next, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    const res = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
    if (!res.ok) throw new Error(String(res.status));
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const items = doc.querySelectorAll('.product-grid > li');
    if (!items.length) throw new Error('no items');

    let firstNew = null;
    items.forEach((item) => {
      const node = document.importNode(item, true);
      if (!firstNew) firstNew = node;
      grid.appendChild(node);
    });

    const shown = grid.querySelectorAll(':scope > li').length;
    const total = Number(link.getAttribute('data-cfw-total')) || shown;
    const newBlock = doc.querySelector('[data-cfw-show-more]');

    if (newBlock && wrapper) {
      wrapper.replaceWith(document.importNode(newBlock, true));
      const status = qs('[data-cfw-show-more] [data-cfw-shown]');
      const left = qs('[data-cfw-show-more] [data-cfw-left]');
      if (status) status.textContent = String(shown);
      if (left) left.textContent = String(Math.max(total - shown, 0));
    } else if (wrapper) {
      wrapper.innerHTML = `<p class="cfw-show-more__status" aria-live="polite">Showing all ${total} styles</p>`;
    }

    const focusTarget = firstNew && firstNew.querySelector('a[href]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  } catch (e) {
    window.location.href = next;
  } finally {
    link.removeAttribute('aria-busy');
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const sortBtn = target.closest('[data-cfw-open-sort]');
  if (sortBtn) {
    const drawer = openDrawer();
    if (!drawer) return;
    window.requestAnimationFrame(() => {
      window.setTimeout(() => {
        const sort = drawer.querySelector('.sorting-filter');
        if (sort) {
          sort.scrollIntoView({ block: 'start' });
          const control = sort.querySelector('select, summary, input');
          if (control) control.focus({ preventScroll: true });
        }
      }, 60);
    });
    return;
  }

  if (target.closest('[data-cfw-see-results]')) {
    window.setTimeout(scrollToGrid, 350);
    return;
  }

  const chip = target.closest('[data-cfw-remove-filter]');
  if (chip) {
    const holder = chip.closest('[data-cfw-form]');
    const form = holder ? document.getElementById(holder.getAttribute('data-cfw-form')) : null;
    if (form && typeof form.updateFiltersByURL === 'function') {
      event.preventDefault();
      form.updateFiltersByURL(chip.getAttribute('href'));
    }
    return;
  }

  const more = target.closest('[data-cfw-next]');
  if (more) {
    event.preventDefault();
    showMore(more);
  }
});
